export default __webpack_public_path__ + "static/media/tools-bj-top.42cd8709.png";